import { createAction, props } from '@ngrx/store';
import { TocTypeInterface } from '../../+models';

export const loadTocTypes = createAction('[TocType] Load TocTypes', props<{ force?: boolean; userId: number }>());

export const tocTypesLoaded = createAction('[TocType] TocTypes Loaded', props<{ tocTypes: TocTypeInterface[] }>());

export const tocTypesLoadError = createAction('[TocType] Load Error', props<{ error: any }>());

export const clearTocTypes = createAction('[TocType] Clear TocTypes');
